import styled from '@emotion/styled';
import { Author, UUID } from '@myme/utils';
import { mq } from 'src/themes';
import { useTranslation } from 'src/hooks';
import { creatorProfilePageRoute, mymeDetailsPageRoute } from 'src/routes/route-list';
import { Link, Typography } from 'src/components/atoms';
import { MymePreviewDescription } from './Description';

interface Props {
  id: UUID;
  name: string;
  author: Author;
  description: string;
}

const StyledMymePreviewDetailsContainer = styled.div`
  position: relative;
  z-index: 10;
  grid-area: details;
  display: flex;
  flex-direction: column;
  align-self: flex-end;
  cursor: pointer;

  ${mq.sm} {
    padding: 1rem 0;
  }
`;

const StyledMymeName = styled(Typography)`
  max-height: 5rem;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
`;

export const MymePreviewDetails = ({ id, name, author, description }: Props) => {
  const { t } = useTranslation();

  return (
    <StyledMymePreviewDetailsContainer>
      <Typography variant='h5'>
        <Link to={mymeDetailsPageRoute(id)}>
          <StyledMymeName variant='body2'>{name}</StyledMymeName>
        </Link>
      </Typography>
      <Typography onClick={e => e.stopPropagation()} variant='body2' fontSize={12} sx={{ mb: 1.5 }}>
        {`${t('pages.feed.myme.author')} `}
        <Link to={creatorProfilePageRoute(author.id)}>{author.name}</Link>
      </Typography>
      <MymePreviewDescription description={description} />
    </StyledMymePreviewDetailsContainer>
  );
};
